export const SET_parceiroS = "parceiroS/SET_parceiroS";
export const SET_parceiro = "parceiroS/SET_parceiro";
export const SET_PAGINATION = "parceiroS/SET_PAGINATION";
